// extracted by mini-css-extract-plugin
module.exports = {"MessageWrapper":"Messages_MessageWrapper__K8fHU","MessageHeader":"Messages_MessageHeader__18uCP","MessageFooter":"Messages_MessageFooter__1Mu7w"};